module.exports = __webpack_public_path__ + "static/media/template1.387dff52.webp";